module.exports = __webpack_public_path__ + "static/media/main_visual_rough_terrain_m_26_2_st5_manitou (1).383079b2.png";